import Chart from 'chart.js';
document.addEventListener("DOMContentLoaded", function () {
    var activeCategory = document.querySelector('.section-calculator .category.active').innerText;
    var rangeValue = document.getElementById('slider-range').value;

    function getAdjustedData() {
        return categoryData[activeCategory].map(value => value * rangeValue * 25);
    }

    function calculateTotalCost() {
        var total = categoryData[activeCategory].reduce((sum, value) => sum + value, 0) * rangeValue * 25;
        document.getElementById('total-year-cost').innerText = total.toLocaleString();
    }

    var currentLang = document.documentElement.lang.slice(0, 2);


    const monthLabels = {
        en: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        es: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"]
    };

    const chartLabels = monthLabels[currentLang] || monthLabels['en'];

    var ctx = document.getElementById('myChart').getContext('2d');
    var myChart = new Chart(ctx, {
        type: 'line',
        data: {
            labels: chartLabels,
            datasets: [{
                data: getAdjustedData(),
                borderColor: '#3D6124',
                borderWidth: 2,
                backgroundColor: '#f0f1e34f',
                pointBackgroundColor: '#3D6124',
                pointRadius: 3
            }]
        },
        options: {
            responsive: true,
            legend: {display: false},
            scales: {
                xAxes: [{
                    offset: true,
                    gridLines: {
                        drawBorder: false,
                        display: false
                    }
                }],
                yAxes: [{
                    offset: true,
                    ticks: {
                        // display: false,
                        // beginAtZero: true,
                        callback: function(value, index, values) {
                            if (window.innerWidth <= 767) {
                                return '';
                            }
                            return value;
                        },
                        beginAtZero: window.innerWidth > 767
                    },
                    gridLines: {
                        drawTicks: false
                    }
                }]
            },
            tooltips: {
                mode: 'nearest',
                intersect: false,
                backgroundColor: "#C7E500",
                bodyFontSize: 16,
                bodyFontColor: "#1B1C1B",
                bodyFontWeight: 400,
                xPadding: 15,
                yPadding: 5,
                displayColors: false,
                callbacks: {
                    title: function (tooltipItem, data) {
                        return ''; // Returns an empty string to remove the title
                    },
                    label: function (tooltipItem, data) {
                        let value = tooltipItem.yLabel;
                        return "€ " + value; // Adding the euro icon
                    }
                },
            },
            elements: {
                line: {
                    fill: true, // Set fill for the line
                    tension: 0.4 // Used to round a line
                },
                point: {
                    radius: 0
                }
            },
            plugins: {
                tooltip: {
                    callbacks: {
                        label: function (tooltipItem) {
                            return tooltipItem.yLabel + ' €'; // Adding the euro icon
                        }
                    }
                }
            }
        }
    });

    // Update when range changes
    const elemWrapper = document.querySelector(".section-calculator .slider-wrapper");
    const elemRange = document.getElementById("slider-range");
    const elemRangeVal = document.getElementById("slider-value");
    const ratio = 100 / (+elemRange.max - +elemRange.min);

    elemRange.addEventListener("input", function () {
        rangeValue = this.value;
        elemRangeVal.textContent = rangeValue;
        const value = ratio * (this.value - elemRange.min);
        elemWrapper.style.setProperty('--value', +value);

        // Schedule update
        myChart.data.datasets[0].data = getAdjustedData();
        myChart.update();

        // Update total cost
        calculateTotalCost();
    });

    elemRange.dispatchEvent(new Event("input"));


    // Update when category changes
    document.querySelectorAll('.section-calculator .category').forEach(category => {
        category.addEventListener('click', function () {
            document.querySelectorAll('.section-calculator .category').forEach(cat => cat.classList.remove('active'));
            this.classList.add('active');
            activeCategory = this.innerText;
            myChart.data.datasets[0].data = getAdjustedData();
            myChart.update();
            calculateTotalCost();
        });
    });

    // We calculate the total amount when loading the page
    calculateTotalCost();


    // center tab
    function centerActiveCategory() {
        if (window.innerWidth < 767) {
            const $activeCategory = $('.section-calculator .category.position-center');

            if ($activeCategory.length) {
                const $scrollContainer = $('.section-calculator .wrap-categories');
                const activeOffsetLeft = $activeCategory[0].offsetLeft;
                const activeWidth = $activeCategory.outerWidth();
                const containerWidth = $scrollContainer.width();
                const scrollPosition = activeOffsetLeft - (containerWidth / 2) + (activeWidth / 2);
                $scrollContainer.animate({scrollLeft: scrollPosition}, 300, 'swing');
            }
        }
    }

    centerActiveCategory();

    $('.section-calculator .category').on('click', function (e) {
        e.preventDefault();
        const $parentItem = $(this);
        $parentItem.addClass('position-center').siblings().removeClass('position-center');
        centerActiveCategory();
    });
});
